var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoAlbum(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 157,
    viewBox: "0 0 168 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2472 137.682L23.5776 138.478C20.5303 138.907 17.7128 136.784 17.2845 133.736L1.77549 23.3837C1.34722 20.3364 3.47037 17.5189 6.51767 17.0906L115.491 1.77547C118.538 1.3472 121.356 3.47033 121.784 6.51763C121.784 6.51763 122.776 13.5735 123.117 16.0006",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7677 131.538L27.6194 132.27C24.8524 132.663 22.2975 130.739 21.913 127.972L7.99016 27.7837C7.60569 25.0171 9.53718 22.4555 12.3043 22.0622L111.257 7.9978C114.024 7.6045 116.579 9.52847 116.963 12.2951L118.16 20.9046C118.224 21.3705 122.499 52.2935 130.983 113.674C131.409 116.756 129.284 119.604 126.236 120.034C126.203 120.039 126.171 120.043 126.138 120.047L32.7677 131.538Z",
    fill: "#FF9D2E",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2472 137.682L23.5776 138.478C20.5303 138.907 17.7128 136.784 17.2845 133.736L1.77549 23.3837C1.34722 20.3364 3.47036 17.5189 6.51766 17.0906L115.491 1.77547C118.538 1.3472 121.356 3.47034 121.784 6.51764C121.784 6.51764 122.776 13.5735 123.117 16.0006",
    stroke: "#FF9D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M124.278 22.4232L124.974 26.7698",
    stroke: "#FF9D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5393 26.5058C47.7125 24.858 49.1887 23.6626 50.8364 23.8358L163.404 35.6672C165.052 35.8404 166.247 37.3166 166.074 38.9643L154.097 152.917C153.924 154.565 152.448 155.761 150.8 155.587L38.2323 143.756C36.5846 143.583 35.3892 142.107 35.5623 140.459L47.5393 26.5058Z",
    fill: "white",
    stroke: "#FF9D2E",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.8065 39.1852C57.9797 37.5374 59.4559 36.3421 61.1037 36.5152L150.724 45.9348C152.372 46.108 153.568 47.5841 153.394 49.2319L145.431 124.999C145.258 126.647 143.782 127.843 142.134 127.669L52.513 118.25C50.8652 118.077 49.6699 116.6 49.843 114.953L57.8065 39.1852Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.9286 96.9441L76.6912 86.9872C78.3248 85.8854 80.5176 86.1374 81.8586 87.5812L93.0166 99.5937C93.3746 99.9791 93.9701 100.021 94.3788 99.69L117.392 81.0432C119.239 79.546 121.978 79.9821 123.269 81.9793L138.122 104.952L140.118 108.284L139.128 120.004C139.081 120.564 138.581 120.976 138.021 120.913L57.8903 112.01C57.3487 111.95 56.9549 111.468 57.0049 110.925L58.0919 99.1205L61.9286 96.9441Z",
    fill: "#FF9D2E",
    fillOpacity: 0.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8011 39.2897C58.9165 38.1912 59.9006 37.3943 60.9992 37.5098L150.62 46.9293C151.718 47.0447 152.515 48.0289 152.4 49.1274L144.436 124.895C144.321 125.993 143.337 126.79 142.238 126.675L52.6176 117.255C51.519 117.14 50.7221 116.156 50.8376 115.057L58.8011 39.2897Z",
    stroke: "#FF9D2E",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 79.0487,
    cy: 63.6129,
    r: 8.35778,
    transform: "rotate(6 79.0487 63.6129)",
    fill: "#FF9D2E",
    fillOpacity: 0.15,
    stroke: "#FF9D2E",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1267 99.0991C64.6099 95.3125 75.5764 87.7394 75.5764 87.7394C77.852 86.2046 80.9064 86.5556 82.7744 88.5667L92.767 99.3246C93.2657 99.8615 94.0952 99.9202 94.6646 99.4588L116.032 82.1448C118.423 80.2075 121.932 80.5752 123.869 82.9661C123.994 83.1206 124.111 83.2817 124.219 83.4487C124.219 83.4487 136.712 103.272 139.631 107.904",
    stroke: "#FF9D2E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAlbum);
export default __webpack_public_path__ + "static/media/noAlbum.4447313c2dcf615654796c39130d0e68.svg";
export { ForwardRef as ReactComponent };